export const EARLIEST_TIME = 0;

export const ONE_HOUR = 60;

export const SNAP_INTERVAL_IN_MINUTES = 15;

export const BASIC_HEIGHT_UNIT = (0.88 * 15) / SNAP_INTERVAL_IN_MINUTES;

export const HEIGHT_OF_ONE_HOUR = ONE_HOUR * BASIC_HEIGHT_UNIT;

export const COLUMN_GAP = 8;

export const TIMELINE_WIDTH = 30;

export const COLUMN_WIDTH = 160;

export const SNAP_INTERVAL_IN_HOURS = SNAP_INTERVAL_IN_MINUTES / ONE_HOUR;

export const SNAP_GAP = SNAP_INTERVAL_IN_HOURS * HEIGHT_OF_ONE_HOUR;

export const SECONDS_PER_MINUTE = 60;

export const HOURS_PER_DAY = 24;

export const MILLISECONDS_PER_SECOND = 1000;

export const HEIGHT_OF_TOP_NAV_BAR = 55;

export const COLUMN_HEIGHT =
  (HOURS_PER_DAY - EARLIEST_TIME) * HEIGHT_OF_ONE_HOUR;
